export class RolTipo {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchRolTipoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveRolTipoDto {
  constructor(
    public readonly Codigo: string | null,
    public Nombre: string | null,
    public Activo: boolean
  ) {}
}

export class SearchRolTipoResponse {
  constructor(
    public readonly count: number,
    public readonly result: RolTipo[]
  ) {}
}
